<template>
  <component class="heading" :is="tag" :style="{ color: color }">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'h1',
    },

    color: {
      type: String,
      default: '#2a1559',
    },
  },
};
</script>

<style lang="scss" scoped>
.heading {
  font-weight: 900;
}

@media (min-width: 768px) {
  .heading {
    font-size: 4rem;
  }

  .heading.is-small {
    font-size: 2.5rem;
  }
}
</style>
